import darkenjs from "./composed/darkenjs.js";
// import swupInit from "./composed/swupjs.js";
import jarallaxjs from "./composed/jarallaxjs.js";
import plyrjs from "./composed/plyrjs.js";
import gridzy from "./composed/gridzy/gridzy.js";
import headerscroll from "./composed/headerscroll.js";
import uIkit from "./composed/uIkit.js";
import widows from "./composed/widows.js";
// import mobilemenu from "./composed/mobilemenu.js";


document.addEventListener("DOMContentLoaded", firstLoadInit);

// const swup = swupInit(".gn-swup-wrapper");

function genericInit() {
    headerscroll.init();
    darkenjs.init();
    gridzy.init();
    jarallaxjs.init();
    plyrjs.init();
    uIkit.init();
    // mobilemenu.init();
    widows.init();
    
    const gnInitEvent = new Event("gnInit");
    document.dispatchEvent(gnInitEvent);


    //adding class to style search results page
      if (window.location.href.indexOf("?search=") > -1) {
        document.body.classList.add("SolidMenu");
    }

    if (window.location.href.indexOf("?filter=") > -1) {
        document.body.classList.add("Show_SmartPag");
    }
}

/**
 * This script cleans up JS which is will no longer be needed on page change
 */
//  function cleanupScripts() {
//     jarallaxjs.cleanup();
//     plyrjs.cleanup();
//     uIkit.cleanup();
// }

// swup.on("willReplaceContent", cleanupScripts);

// // init js when Swup has replaced page
// swup.on("contentReplaced", pageSwapInit);

// // run some things when links are clicked.

// function pageSwapInit() {
//     genericInit();
// }


function firstLoadInit() {
    // if (window.location.href.indexOf("&action_results=Go") > -1) {
    //     document.body.classList.remove("SolidMenu");
    // }


    if (window.location.href.indexOf("category") > -1) {
        document.body.classList.add("Hide-Pag");
    }
    genericInit();
}
